module.exports = __webpack_public_path__ + "img/orange-bg.35def758.png";